import { render, staticRenderFns } from "./ChooseCategories.vue?vue&type=template&id=397dea57&scoped=true&"
import script from "./ChooseCategories.vue?vue&type=script&lang=js&"
export * from "./ChooseCategories.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCategories.vue?vue&type=style&index=0&id=397dea57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397dea57",
  null
  
)

export default component.exports